/* =====================================================================
   2% Clothing Club — shared front-end behaviour
   Reveal-on-scroll, mobile nav, seamless marquee, countdown timers.
   Safe to run multiple times (re-inits on Shopify section load).
   ===================================================================== */
(function () {
  'use strict';

  /* ---- Reveal on scroll (fade + slight Y) ---- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.twopct-reveal:not([data-revealed])');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { el.setAttribute('data-revealed', ''); io.observe(el); });
  }

  /* ---- Mobile navigation ---- */
  function initHeader(root) {
    var headers = (root || document).querySelectorAll('[data-twopct-header]:not([data-init])');
    headers.forEach(function (header) {
      header.setAttribute('data-init', '');
      var toggle = header.querySelector('[data-twopct-menu-toggle]');
      var closeEls = header.querySelectorAll('[data-twopct-menu-close]');
      function setOpen(open) {
        header.classList.toggle('is-open', open);
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.documentElement.classList.toggle('twopct-no-scroll', open);
      }
      if (toggle) {
        toggle.addEventListener('click', function () {
          setOpen(!header.classList.contains('is-open'));
        });
      }
      closeEls.forEach(function (el) { el.addEventListener('click', function () { setOpen(false); }); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') setOpen(false);
      });
      // sticky shadow / shrink
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    });
  }

  /* ---- Seamless marquee (duplicate track content) ---- */
  function initMarquee(root) {
    var tracks = (root || document).querySelectorAll('[data-twopct-marquee]:not([data-init])');
    tracks.forEach(function (track) {
      track.setAttribute('data-init', '');
      var html = track.innerHTML;
      track.innerHTML = html + html;
    });
  }

  /* ---- Countdown timers ---- */
  function initCountdowns(root) {
    var nodes = (root || document).querySelectorAll('[data-twopct-countdown]:not([data-init])');
    nodes.forEach(function (node) {
      node.setAttribute('data-init', '');
      var deadline = new Date(node.getAttribute('data-deadline')).getTime();
      var elD = node.querySelector('[data-d]'), elH = node.querySelector('[data-h]');
      var elM = node.querySelector('[data-m]'), elS = node.querySelector('[data-s]');
      if (isNaN(deadline)) return;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = deadline - Date.now();
        if (diff < 0) diff = 0;
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (elD) elD.textContent = pad(d);
        if (elH) elH.textContent = pad(h);
        if (elM) elM.textContent = pad(m);
        if (elS) elS.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---- Hero slideshow ---- */
  function initHero(root) {
    var heroes = (root || document).querySelectorAll('[data-twopct-hero]:not([data-init])');
    heroes.forEach(function (hero) {
      hero.setAttribute('data-init', '');
      var slides = hero.querySelectorAll('[data-hero-slide]');
      var dots = hero.querySelectorAll('[data-hero-dot]');
      if (slides.length < 2) return;
      var idx = 0;
      function go(n) {
        slides[idx].classList.remove('is-active');
        if (dots[idx]) dots[idx].classList.remove('is-active');
        idx = (n + slides.length) % slides.length;
        slides[idx].classList.add('is-active');
        if (dots[idx]) dots[idx].classList.add('is-active');
      }
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { go(parseInt(dot.getAttribute('data-hero-dot'), 10)); reset(); });
      });
      var timer;
      function reset() { clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, 5500); }
      reset();
    });
  }

  function initAll(root) {
    initReveal(root);
    initHeader(root);
    initMarquee(root);
    initCountdowns(root);
    initHero(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Shopify theme editor: re-init when a section is loaded/re-rendered
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
